import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 获取当前学年 SKU 列表
  getCurrentYearGoodsList(params) {
    return http.post(URL.API_RIGHTS_GET_CURRENT_YEAR_SKU_LIST, params)
  },
  // 获取商品/支付页（购买/续费）
  getGoodPage(data) {
    return http.post(URL.API_ORDER_GET_GOOD_PAGE, data)
  }
}
